import { apiClientWithRefreshToken } from "@/api/apiClient";

export default async function DeleteInvoice(id: string): Promise<void> {
    await apiClientWithRefreshToken({
        url: `/invoices/${id}`,
        method: "DELETE",
    });
}
